import ClarityClient from '@clarity-website/lib/clients/ClarityClient';
import { useMemo } from 'react';

export default function useClarityClient() {
  return useMemo(() => new ClarityClient(), []);
}
